import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { slideFadeAnimation } from '@plugins/client/animation';
import { DialogComponent } from '@plugins/client/dialog/dialog.component';
import { DIALOG_DATA } from '@plugins/client/dialog/tokens';
import { NoticeComponent } from '@plugins/client/notice';
import { DompurifyPipe } from '@plugins/client/pipes/html/dompurify.pipe';
import { Nl2BrPipe } from '@plugins/client/pipes/html/nl2br.pipe';

import { ToastData } from './types';

@Component({
  selector: 'plugins-toast',
  imports: [CommonModule, NoticeComponent, Nl2BrPipe, DompurifyPipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  animations: [slideFadeAnimation('toast', 'top', 'top')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  readonly data = inject(DIALOG_DATA) as ToastData;
  readonly dialogRef = inject(DialogComponent);
  showToast = true;

  onClose() {
    this.showToast = false;
  }

  onAnimationDone() {
    if (!this.showToast) {
      this.dialogRef.close();
    }
  }
}
